import { isBoolean, isEqual } from 'lodash-es';
import { Maybe, getIsNotNullable } from './nullable-utils';

export const getIsString = (val: any): val is string => typeof val === 'string';
const getIsNumber = (val: any): val is number => typeof val === 'number';
export const getIsFiniteNumber = (val: any): val is number => getIsNumber(val) && Number.isFinite(val);
type ID = string | number;

export const CompareIds = <T extends Maybe<ID>>(first: T, second: T) =>
  // eslint-disable-next-line eqeqeq
  getIsNotNullable(first) && (getIsString(first) || getIsFiniteNumber(first)) && first == second;

type MaybeBoolean = Maybe<string | number | boolean>;
export const toBoolean = (value: MaybeBoolean): boolean =>
  isBoolean(value)
    ? value
    : typeof value === 'string'
      ? value.toLowerCase() === 'true'
      : getIsFiniteNumber(value)
        ? !!value
        : false;

type Primitive = string | number | boolean;
export const ComparePrimitives =
  <T extends Primitive>(first?: T) =>
  <T>(second?: T) =>
    isEqual(first, second);
